import { createPluginManager as n } from "../plugin-manager.js";
import { inject as e } from "vue";
const t = Symbol(), i = () => {
  const r = e(t);
  return r || n({});
};
export {
  t as PLUGIN_MANAGER_SYMBOL,
  i as usePluginManager
};
